/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import classNames from 'classnames';
import { Button, Image, Trigger, TriggerInfo } from 'app/components';
import { useWindowSize } from 'app/hooks';
import useConfig from 'app/hooks/useConfig';
import { BonusInfoWrapper, BonusCardContent, Expander } from './styles';

const propTypes = {
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  fetchContent: PropTypes.func.isRequired
};

const defaultProps = {
  content: []
};

const BonusCardInfo = ({ content, fetchContent }) => {
  const [t, i18n] = useTranslation();
  const { cineplexUrl } = useConfig();
  const [bonusCardContent, setBonusCardContent] = useState({
    picture: '',
    recharge: {
      headline: '',
      description: '',
      rechargeData: []
    },
    upgrade: {
      headline: '',
      description: ''
    },
    faq: {
      headline: '',
      faqData: []
    },
    advantages: {
      headline: '',
      advantagesData: []
    },
    rewards: {
      info: '',
      rewardsData: []
    }
  });
  const [isExpanded, setIsExpanded] = useState([]);
  const { width } = useWindowSize();

  useEffect(() => {
    fetchContent();
  }, [i18n.language]);

  useEffect(() => {
    if (content?.length) {
      const { picture, PictureEN, advantages, rewards, recharge, upgrade, faq, bottom } = content[0];

      setBonusCardContent({
        picture: i18n.language === 'en' || i18n.language === 'en-US' ? PictureEN : picture,
        advantages,
        rewards,
        recharge,
        upgrade,
        faq,
        bottom
      });
    }
  }, [content]);

  useEffect(() => {
    if(process.env.REACT_APP_COUNTRY === "svn"){
      document.title = "Cineplexx | Bonus Kartica"
    }

    return () => {
      document.title = "Cineplexx"
    };

  }, [])

  const setExpandCb = useCallback(
    id => {
      const expandList = [...isExpanded];

      if (expandList.includes(id)) {
        expandList.splice(expandList.indexOf(id), 1);
      } else {
        expandList.push(id);
      }

      setIsExpanded(expandList);
    },
    [isExpanded]
  );

  const languageContents = useMemo(
    () => ({
      headline: i18n.language === 'en' || i18n.language === 'en-US' ? 'headlineEN' : 'headline',
      info: i18n.language === 'en' || i18n.language === 'en-US' ? 'infoEN' : 'info',
      title: i18n.language === 'en' || i18n.language === 'en-US' ? 'titleEN' : 'title',
      description: i18n.language === 'en' || i18n.language === 'en-US' ? 'descriptionEN' : 'description',
      linkDescription: i18n.language === 'en' || i18n.language === 'en-US' ? 'linkDescriptionEN' : 'linkDescription',
    }),
    [i18n.language]
  );

  return (
    <BonusInfoWrapper>
      {content?.length > 0 && bonusCardContent?.picture && (
        <>
          <h1 className="bonus-info__title">{t('common.card_info')}</h1>
          <BonusCardContent>
            <Image
              src={bonusCardContent?.picture}
              className={classNames('bonus-card-info__image', {
                'bonus-card-info__image-mobile': width <= 740
              })}
            />
            <div className="bonus-card-info__content-wrapper">
              <div className="bonus-card-info__container">
                <div className='bonus-card-info__title-wrapper-container'>
                  <div className="bonus-card-info__title-wrapper">
                    <h2>{bonusCardContent?.advantages?.[languageContents.headline]}</h2>
                    <div className="bonus-card-info__advantages-container">
                      <div className="bonus-card-info__advantages-wrapper">
                        {bonusCardContent?.advantages?.advantagesData?.map((item, index) => (
                          <div key={index} className="bonus-card-info__advantage-item">
                            <Image src={item?.picture} />
                            <div className="bonus-card-info__advantage-item-description">
                              {parse(item?.[languageContents.description])}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="bonus-card-info__rewards-item-wrapper">
                      {bonusCardContent?.rewards?.rewardsData?.map((item, index) => (
                        <div key={index} className="bonus-card-info__rewards-item">
                          <Image src={item?.picture} />
                          {width > 740 ? (
                            <>
                              <h3>{item?.points}</h3>
                              <div className="bonus-card-info__rewards-item-description">
                                {parse(item?.[languageContents.description])}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="bonus-card-info__rewards-item-description">
                                {parse(item?.[languageContents.description])}
                              </div>
                              <h3>{item?.points}</h3>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className="bonus-card-info__rewards-description-wrapper">
                      {parse(bonusCardContent?.rewards?.[languageContents.info])}
                    </div>
                  </div>
                </div>
                <div className="bonus-card-info__recharge-wrapper">
                  <h2>{bonusCardContent?.recharge?.[languageContents.headline]}</h2>
                  <div className="bonus-card-info__registration-wrapper">
                    <a
                      href={`${cineplexUrl}/sign-up`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button type="button" isPrimary className="bonus-card-info__registration-btn">
                        {t('common.join')}
                      </Button>
                    </a>
                  </div>
                  <div className="bonus-card-info__recharge-description-wrapper">
                    {parse(bonusCardContent?.recharge?.[languageContents.description])}
                  </div>
                  <div className="bonus-card-info__recharge-data-wrapper">
                    {bonusCardContent?.recharge?.rechargeData?.map((item, index) => (
                      <div key={index} className="bonus-card-info__recharge-data-item">
                        <h3 className='desciption_h3'>
                          {(item?.descriptionEN !== null || item?.description !== null) && parse(item?.[languageContents.description]).length > 0 ?
                            parse(item?.[languageContents.description])
                            : <img src={item?.picture} alt="bonus-card-recharge" />
                          }
                        </h3>
                        <h2 className='desciption_h2'>
                          {item?.link !== null && item?.[languageContents.linkDescription]?.length > 0 ?
                            // eslint-disable-next-line
                            <a href={item?.link} className='text-left'>{item?.[languageContents.linkDescription]}</a>
                            : item?.price
                          }
                        </h2>
                      </div>
                    ))}
                  </div>
                  <div className="bonus-card-info__recharge-description2-wrapper">
                    {parse(bonusCardContent?.recharge?.[languageContents.info])}
                  </div>
                </div>
                <div className="bonus-card-info__upgrade-wrapper">
                  <h2>{bonusCardContent?.upgrade?.[languageContents.headline]}</h2>
                  <div className="bonus-card-info__upgrade-description-wrapper">
                    {parse(bonusCardContent?.upgrade?.[languageContents.description])}
                  </div>
                </div>
                <div className="bonus-card-info__faq-wrapper">
                  <h2>{bonusCardContent?.faq?.[languageContents.headline]}</h2>
                  {bonusCardContent?.faq?.faqData?.map((item, index) => (
                    <div key={index} className="bonus-card-info__faq-item-wrapper">
                      <TriggerInfo
                        isExpanded={isExpanded.includes(index)}
                        onClick={() => setExpandCb(index)}
                      >
                        <div className="bonus-card-info__faq-item">
                          <h3>{item?.[languageContents.title]}</h3>
                          <Trigger
                            isExpanded={isExpanded.includes(index)}
                            onClick={() => setExpandCb(index)}
                          >
                            <span className="_with-chevron" />
                          </Trigger>
                        </div>
                      </TriggerInfo>
                      <Expander isExpanded={isExpanded.includes(index)}>
                        <div className="bonus-card-info__faq-item-expand-content">
                          {parse(item?.[languageContents.description])}
                        </div>
                      </Expander>
                    </div>
                  ))}
                </div>
                <div className="bonus-card-info__terms-wrapper">
                  {/*  eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                  <a href={bonusCardContent?.bottom?.link} target="_blank" rel="noopener noreferrer">{bonusCardContent?.bottom?.[languageContents.linkDescription]}</a>
                </div>
              </div>
            </div>

          </BonusCardContent>
        </>
      )}
    </BonusInfoWrapper>
  );
};

BonusCardInfo.propTypes = propTypes;
BonusCardInfo.defaultProps = defaultProps;
export default BonusCardInfo;
